const lenis = new Lenis()

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

gsap.registerPlugin(ScrollTrigger,  ScrollToPlugin);

if (window.innerWidth >= 768) {

  const overlays = gsap.utils.toArray(".img__overlay");

overlays.forEach(overlay => {
  gsap.fromTo(
    overlay,
    { height: "100%" }, 
    { 
      height: "0%",     
      duration: 1.5,
      ease: "power4.inOut",
      scrollTrigger: {
        trigger: overlay.closest(".section-dual-tiles"),
        start: "top 90%", 
        end: "bottom top",       
      }
    }
  );
});

// ANIMATION POUR L'AFFICHAGE DES TITRES ET PARAGRAPHES EN FADE

// Vérifie si on est sur la page "nos revendeurs"
if (!document.body.classList.contains("template--nos-revendeurs")) {
  const beforeAfterParagraphs = document.querySelectorAll(".before-and-after-grid-col-text-content-text-container p");
  const dualTilesParagraphs = document.querySelectorAll(".section-dual-tiles__entry p");
  const seoContentParagraphs = document.querySelectorAll(".section-seo-content__content .entry p");

  const allParagraphs = [...beforeAfterParagraphs, ...dualTilesParagraphs, ...seoContentParagraphs];

  allParagraphs.forEach((p) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("content-wrapper-animation");

    p.parentNode.insertBefore(wrapper, p);
    wrapper.appendChild(p);
  });

  const animationTexts = [...gsap.utils.toArray(".section__title"), ...allParagraphs];

  animationTexts.forEach((text) => {
    gsap.fromTo(
      text,
      { y: "150%" },
      { 
        y: "0%", 
        duration: 1.5, 
        ease: "power4.inOut", 
        scrollTrigger: {
          trigger: text,
          start: "top-=200 bottom",
          end: "bottom top",
        }
      }
    );
  });
}

  // Images parallax
  
if (window.location.pathname === '/') {
    const container = document.querySelector('.hero__media');
    const img = container.querySelector('img'); 
  
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        scrub: true,
        pin: false,
      }
    });
  
    tl.fromTo(img, {
      yPercent: -20,
      ease: 'none'
    }, {
      yPercent: 20,
      ease: 'none'
    });
  }
  
  
  
  gsap.utils.toArray('.section-dual-tiles__media').forEach(container => {
    const img = container.querySelector('img');
    
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: "top 90%",
        scrub: true,
        pin: false,
      }
    });
  
    tl.fromTo(img, 
      {
        yPercent: 10,
        ease: 'none'
      }, 
      {
        yPercent: -5,
        ease: 'none'
      }
    );
  
  });


    gsap.utils.toArray('.section-trust-indicators__decorator').forEach((element, index) => {
      gsap.fromTo(element, 
        {
          opacity: 0,      
        }, 
        {
          opacity: 1,     
          duration: 1.5,  
          ease: 'power2.out',
          scrollTrigger: {
            trigger: element,        
            start: 'top 80%',        
            end: 'bottom 60%',       
            toggleActions: 'play none none reverse',
            markers: false          
          }
        }
      );
    });
  
}


    const footerContentEntry = document.querySelector(".footer__content-entry h5 p");
    const formNewsletter = document.querySelector('#contact-form-075332fc-22c3-4d56-9cb5-95c07cf43430');

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('customer_posted') && urlParams.get('customer_posted') === 'true') {
        localStorage.setItem('newsletterSubmitted', 'true');
    }

    if (localStorage.getItem('newsletterSubmitted') === 'true') {
        if (footerContentEntry) {
            footerContentEntry.textContent = "Bienvenue dans le crew !";
        }
        if(formNewsletter) {
          formNewsletter.style.display = "none";
        }
    }



(function() {


   const p = document.querySelector(
    '#shopify-section-template--23615361450325__dual_tiles_X4tbnA > section > div > div > div.section-dual-tiles__entry.h5 > div:nth-child(5) > p'
  );

  if (p) {
    const svgIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256">
        <path d="M243.31,136,144,36.69A15.86,15.86,0,0,0,132.69,32H40a8,8,0,0,0-8,8v92.69A15.86,15.86,0,0,0,36.69,144L136,243.31a16,16,0,0,0,22.63,0l84.68-84.68a16,16,0,0,0,0-22.63ZM84,96A12,12,0,1,1,96,84,12,12,0,0,1,84,96Z"></path>
      </svg>
    `;

    const wrapper = document.createElement("span");
    wrapper.innerHTML = svgIcon;
    wrapper.style.display = "inline-flex";
    wrapper.style.marginRight = "8px";
    wrapper.style.verticalAlign = "middle";

    // Insérer le SVG en tout premier dans le <p>
    p.insertBefore(wrapper, p.firstChild);
  }

})();
